import React, {
  useState,
  useEffect,
  useCallback,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import DatePicker from "react-datepicker";
import Checkbox from "@mui/material/Checkbox";
import {
  HippaAuthConstant,
  IntakeSheetSession,
  RoleType,
} from "../../../Constant";
import {
  CallApiForProviderList,
  GragIntakeFormData,
  GragIntakeSheetData,
} from "../IntakeSheetUtils";
import moment from "moment";
import toast from "react-hot-toast";
import { GetCaseFormListData, SaveCaseFormData } from "../Service";
import SignaturePad from "../../../Component/shared/signaturePad";
import "./HippaAuthorization.css";
import SpinnerLoader from "../../../Component/shared/loader/spinnerLoader/SpinnerLoader";
import { usePatientData } from "../../../commonFunction/storage/Patientdatacontext";


const HippaAuth = forwardRef(function HippaAuth(props, ref) {
  const [loading, setLoading] = useState(false);
  const [DOB, setDOB] = useState(new Date());
  const [addressOfPatient, setAddressOfPatient] = useState("");
  const [SSN, setSSN] = useState("");
  const [SignDate, setSignDate] = useState(new Date());
  const [NameAddressHealthProviderInfo, setNameAddressHealthProviderInfo] = useState("");
  const [NameAddressOfPerson, setNameAddressOfPerson] = useState("");
  const [chkMedicalRecordDate, setChkMedicalRecordDate] = useState(false);
  const [medicalRecordForm, setMedicalRecordForm] = useState(new Date());
  const [submitToDate, setSubmitToDate] = useState(new Date());
  const [chkEntireMedicalRecord, setChkEntireMedicalRecord] = useState(false);
  const [chkOther, setChkOther] = useState(false);
  const [otherComment, setOtherComment] = useState("");
  const [alcohalDrugTreatment, setAlcohalDrugTreatment] = useState("");
  const [mentalHealthInfo, setMentalHealthInfo] = useState("");
  const [HIVInfo, setHIVInfo] = useState("");
  const [chkIntialting, setChkIntialting] = useState(false);
  const [intialing, setIntialing] = useState("");
  const [authorize, setAuthorize] = useState("");
  const [discussHelathInfoWithAttorney, setDiscussHelathInfoWithAttorney] = useState("");
  const [chkRequestOfIndividualSubmit, setChkRequestOfIndividualSubmit] = useState(false);
  const [chkOtherReleaseInfo, setChkOtherReleaseInfo] = useState(false);
  const [expireDate, setExpireDate] = useState(new Date());
  const [nameOfAnotherPreson, setNameOfAnotherPreson] = useState("");
  const [authToSignBehalfOfPatient, setAuthToSignBehalfOfPatient] = useState("");
  const [signRole, setSignRole] = useState("");
  const [collectionOfhippaAuth, setCollectionOfhippaAuth] = useState([]);
  const [SearchResult, setSearchResult] = useState([]);
  const [patientSignImg, setPatientSignImg] = useState("");
  const [BeforeParsinghippaAuthData, setBeforeParsinghippaAuthData] = useState([]);
  const [IsFormCompleted, setIsFormCompleted] = useState(false);
  const [CaseFormDataId, setCaseFormDataId] = useState("");
  const [isCalledFromIntakeSheet, setIsCalledFromIntakeSheet] = useState(false);
  const [isSelectedProvider, setIsSelectedProvider] = useState(false);
  const [caseFormData, setCaseFormData] = useState({});
  const [patientName, setPatientName] = useState("");
  const [sigPadOpen, setSigPadOpen] = useState(false);

  const { patientData, fetchPatientData } = usePatientData();

  const stateRef = useRef({});
  useEffect(() => {
    stateRef.current = {
      collectionOfhippaAuth,
      BeforeParsinghippaAuthData,
      CaseFormDataId,
      caseFormData,
      patientName,
      DOB,
      addressOfPatient,
      SSN,
      SignDate,
      NameAddressHealthProviderInfo,
      NameAddressOfPerson,
      chkMedicalRecordDate,
      medicalRecordForm,
      submitToDate,
      chkEntireMedicalRecord,
      chkOther,
      otherComment,
      alcohalDrugTreatment,
      mentalHealthInfo,
      HIVInfo,
      chkIntialting,
      intialing,
      authorize,
      discussHelathInfoWithAttorney,
      chkRequestOfIndividualSubmit,
      chkOtherReleaseInfo,
      expireDate,
      nameOfAnotherPreson,
      authToSignBehalfOfPatient,
      patientSignImg,
      patientData,
    };
  });

  const tokenData = JSON.parse(sessionStorage.getItem("tokenData") || {});

  const filterData = (constant, collection) => {
    const src = collection || collectionOfhippaAuth;
    const item = src.filter((x) => x.Name === constant)[0];
    const data = item ? item.Value : "";
    return data === "01/01/1900" ? "" : data;
  };

  const generatePatientAddress = () => {
    try{
    const { patientAddress, patientStreet, patientCity, patientStateName, patientZip } = patientData || {};
    return [patientAddress, patientStreet, patientCity, patientStateName, patientZip]
      .filter(Boolean)
      .join(", ");
    }
    catch(error){
      console.error("Error generating patient address", error);
    }
  };

  useEffect(() => { callApi(); }, [patientData]);

  useEffect(() => {
    props?.onReady?.("hipaa_auth");
  }, [patientSignImg]);

  const checkIsPending = () => {
    return !stateRef.current.patientSignImg;
  };

  useImperativeHandle(ref, () => ({
    save: () => saveFunction(),
    isPending: () => checkIsPending(),
    getSignature: () => stateRef.current.patientSignImg || "",
    applySignature: (sig) => {
      if (!sig) return;
      setPatientSignImg(sig);
      setSignDate(new Date());
    },
  }));

  const handleGetCaseFormData = async () => {
    try {
      let requestBody = {
        CaseFormDataId: null,
        CaseId: tokenData.caseId,
        CompanyId: tokenData.companyId,
        DoctorId: "ALL",
        EntityLevel: 0,
        FormId: 2,
        FormName: "HIPPA Authorization",
        FormType: null,
        IsFormCompleted: false,
        JsonData: null,
        TemplateName: null,
        UserId: tokenData?.userId,
      };
      const response = await GetCaseFormListData(requestBody);
      if (response?.HasException) {
        toast.error(`Something went wrong. ${response?.MessageText}. ${response?.Exception}`);
      } else {
        let data = response?.Data[0] || {};
        setCaseFormData(data);
        return data;
      }
    } catch (error) {
      toast.error(error.message);
      return {};
    }
  };

  const CallSaveApiForIntakeSheet = async (jsonData) => {
    try {
      const s = stateRef.current;
      const payload = {
        CaseFormDataId: s.CaseFormDataId || s.caseFormData?.CaseFormDataId || null,
        CaseId: tokenData.caseId,
        CompanyId: tokenData.companyId,
        DoctorId: tokenData?.doctorId,
        EntityLevel: 0,
        FormId: 2,
        FormName: "HIPPA Authorization",
        FormType: null,
        IsChanged: false,
        IsCopySign: false,
        IsFormCompleted: false,
        TemplateName: null,
        UserId: tokenData?.userId,
        officeId: tokenData?.providerId,
        JsonData: jsonData,
      };
      const response = await SaveCaseFormData(payload);
      if (response.HasException) {
        toast.error("Error while saving Hippa authorization.");
        return false;
      } else {
        if (response?.Data?.[0]?.CaseFormDataId) {
          setCaseFormDataId(response.Data[0].CaseFormDataId);
        }
        toast.success("Hippa Authorization saved successfully.");
        return true;
      }
    } catch {
      toast.error("Error while saving Hippa authorization.");
      return false;
    }
  };

  const createProviderInfoView = (providerData) => {
    const { Address, Street, City, State, Zip } = providerData;
    return [tokenData.providerName, Address, Street, City, State, Zip].filter(Boolean).join(", ");
  };

  const bindValueToControl = (collection, patientInfo, providerData) => {
    const rawSign = filterData(HippaAuthConstant.PatientSign, collection);
    let patientSign = "";
    if (rawSign) {
      patientSign = rawSign.includes(IntakeSheetSession.dataBlock)
        ? rawSign
        : IntakeSheetSession.dataBlock + rawSign;
    }
    setAddressOfPatient(generatePatientAddress());
    setSSN(patientInfo?.ssn);
    setNameAddressHealthProviderInfo(createProviderInfoView(providerData));
    setNameAddressOfPerson(filterData(HippaAuthConstant.ReceiverInfo, collection));
    setChkMedicalRecordDate(filterData(HippaAuthConstant.MedRecord9A, collection));
    const rawMedFrom = filterData(HippaAuthConstant.MedRecordFromDt9A, collection);
    setMedicalRecordForm(
  rawMedFrom ? new Date(rawMedFrom) : null
);
    const rawMedTo = filterData(HippaAuthConstant.MedRecordToDt9A, collection);
    setSubmitToDate(
  rawMedTo ? new Date(rawMedTo) : null
);
    setChkEntireMedicalRecord(filterData(HippaAuthConstant.AllMedRecord9A, collection));
    setChkOther(filterData(HippaAuthConstant.OtherRecord9A, collection));
    setOtherComment(filterData(HippaAuthConstant.OtherTxtRecord9A, collection));
    setAlcohalDrugTreatment(filterData(HippaAuthConstant.MedIncAlcDrug9A, collection));
    setHIVInfo(filterData(HippaAuthConstant.MedIncHIVInfo9A, collection));
    setChkIntialting(filterData(HippaAuthConstant.ByInitiate9B, collection));
    setIntialing(filterData(HippaAuthConstant.InitiateHere9B, collection));
    setAuthorize(filterData(HippaAuthConstant.IAuthorize9B, collection));
    setDiscussHelathInfoWithAttorney(filterData(HippaAuthConstant.FirmGovAgency9B, collection));
    setChkRequestOfIndividualSubmit(filterData(HippaAuthConstant.ReasonAtRequest10, collection));
    setChkOtherReleaseInfo(filterData(HippaAuthConstant.ReasonOther10, collection));
    const rawExpire = filterData(HippaAuthConstant.AuthExpireDate11, collection);
    setExpireDate(isNaN(new Date(rawExpire).getTime()) ? "" : new Date(rawExpire));
    setNameOfAnotherPreson(filterData(HippaAuthConstant.OtherPersonName12, collection));
    setAuthToSignBehalfOfPatient(filterData(HippaAuthConstant.OtherAuthority13, collection));
    const rawSignDate = filterData(HippaAuthConstant.FormDate, collection);
    // setSignDate(isNaN(new Date(rawSignDate).getTime()) ? "" : new Date(rawSignDate));
    setSignDate(
  isNaN(new Date(rawSignDate).getTime()) ? null : new Date(rawSignDate)
);
    setMentalHealthInfo(filterData(HippaAuthConstant.MedIncMentalHealth9A, collection));
    // setPatientSignImg(patientSign);
    const savedSig = props.copySignature
      ? sessionStorage.getItem("sharedPatientSignature")
      : null;
    setPatientSignImg(savedSig || patientSign); // CHANGED
    setIsSelectedProvider(false);
    setLoading(false);
  };

  const callApi = async () => {
    setLoading(true);
    const formData = await handleGetCaseFormData();
    const patientInfo = patientData || await fetchPatientData(tokenData?.caseId, tokenData?.companyId);
    setPatientName(patientInfo?.patientFirstName + ' ' + patientInfo?.patientLastName);
    const providerData = await CallApiForProviderList(tokenData?.companyId, tokenData?.providerId);
    const hippaAuthData = JSON.parse(formData?.JsonData);
    const collection = GragIntakeSheetData(hippaAuthData);
    setCollectionOfhippaAuth(collection);
    setBeforeParsinghippaAuthData(hippaAuthData);
    setCaseFormDataId(formData.CaseFormDataId);
    bindValueToControl(collection, patientInfo, providerData);
    setLoading(false);
  };

  const updateCollection = (collection, vals) => {
    try {
      const currentVals = vals || stateRef.current;
      const updated = [...(collection || [])];
      const set = (key, value) => {
        const item = updated.find((x) => x.Name === key);
        if (item) item.Value = value;
      };
      const formatDate = (d) =>
        d == null || d === "" ? "" : moment(d).format("MM-DD-YYYY").split("-").join("/");

      set(HippaAuthConstant.PatientName, currentVals.patientName);
      set(HippaAuthConstant.PatientBirthDate, formatDate(currentVals.patientData?.patientDOB || currentVals.DOB));
      set(HippaAuthConstant.PatientAddress, generatePatientAddress());
      set(HippaAuthConstant.PatientSSN, currentVals.SSN || currentVals.patientData?.ssn || "");
      set(HippaAuthConstant.HealthProviderInfo, currentVals.NameAddressHealthProviderInfo);
      set(HippaAuthConstant.ReceiverInfo, currentVals.NameAddressOfPerson);
      set(HippaAuthConstant.MedRecord9A, currentVals.chkMedicalRecordDate);
      set(HippaAuthConstant.MedRecordFromDt9A, currentVals.medicalRecordForm ? formatDate(currentVals.medicalRecordForm) : "");
      set(HippaAuthConstant.MedRecordToDt9A, currentVals.submitToDate ? formatDate(currentVals.submitToDate) : "");
      set(HippaAuthConstant.AllMedRecord9A, currentVals.chkEntireMedicalRecord);
      set(HippaAuthConstant.OtherRecord9A, currentVals.chkOther);
      set(HippaAuthConstant.OtherTxtRecord9A, currentVals.otherComment);
      set(HippaAuthConstant.MedIncAlcDrug9A, currentVals.alcohalDrugTreatment);
      set(HippaAuthConstant.MedIncHIVInfo9A, currentVals.HIVInfo);
      set(HippaAuthConstant.ByInitiate9B, currentVals.chkIntialting);
      set(HippaAuthConstant.InitiateHere9B, currentVals.intialing);
      set(HippaAuthConstant.IAuthorize9B, currentVals.authorize);
      set(HippaAuthConstant.FirmGovAgency9B, currentVals.discussHelathInfoWithAttorney);
      set(HippaAuthConstant.ReasonAtRequest10, currentVals.chkRequestOfIndividualSubmit);
      set(HippaAuthConstant.ReasonOther10, currentVals.chkOtherReleaseInfo);
      set(HippaAuthConstant.AuthExpireDate11, currentVals.expireDate ? formatDate(currentVals.expireDate) : "");
      set(HippaAuthConstant.OtherPersonName12, currentVals.nameOfAnotherPreson);
      set(HippaAuthConstant.OtherAuthority13, currentVals.authToSignBehalfOfPatient);
      set(HippaAuthConstant.MedIncMentalHealth9A, currentVals.mentalHealthInfo);
      set(HippaAuthConstant.FormDate, formatDate(currentVals.SignDate));
      set(HippaAuthConstant.ProviderName, tokenData.providerName);
      set(HippaAuthConstant.PatientSign, currentVals.patientSignImg);
      return updated;
    } catch (error) {
      console.error(error?.message);
    }
  };

  const formJsonRequest = async (updatedCollection, BeforeParsingData) => {
    try {
      if (!BeforeParsingData || !BeforeParsingData.notesdata) {
        console.error("No notesdata found in BeforeParsinghippaAuthData");
        return false;
      }
      const clone = JSON.parse(JSON.stringify(BeforeParsingData));
      for (let i = 0; i < clone.notesdata.length; i++) {
        if (!clone.notesdata[i].ApplicationValue) continue;

        for (let j = 0; j < clone.notesdata[i].ApplicationValue.length; j++) {
          const appVal = clone.notesdata[i].ApplicationValue[j];
          const matchingItem = updatedCollection.find((x) => x.Name === appVal.Name);

          if (matchingItem) {
            appVal.Type = matchingItem.Type;
            appVal.isRender = matchingItem.isRender;
            if (appVal.Name === HippaAuthConstant.PatientSign) {
              const val = matchingItem.Value;
              if (val) {
                if (val.includes(";")) {
                  const block = val.split(";");
                  appVal.Value = block[1].split(",")[1];
                } else {
                  appVal.Value = val;
                }
              } else {
                appVal.Value = "";
              }
            } else {
              appVal.Value = matchingItem.Value !== undefined ? matchingItem.Value : "";
            }
          }
        }
      }
      const result = await CallSaveApiForIntakeSheet(JSON.stringify(clone));
      setCollectionOfhippaAuth(updatedCollection);
      setBeforeParsinghippaAuthData(clone);
      return result;
    } catch (error) {
      console.error(error.message);
      return false;
    }
  };

  const saveFunction = async () => {
    try {
      setLoading(true);
      const s = stateRef.current;
      const updatedCollection = updateCollection(s.collectionOfhippaAuth, s);
      const result = await formJsonRequest(updatedCollection, s.BeforeParsinghippaAuthData);
      setLoading(false);
      return result;
    } catch (error) {
      setLoading(false);
      console.error(error?.message);
      return false;
    }
  };

  const clickPatientSign = () => {
    setSearchResult({});
    setSigPadOpen(true);
    setSignRole(RoleType.Patient);
    setIsCalledFromIntakeSheet(true);
  };

  const SignUpdatedCall = (base64Img) => {
    const newBaseString = base64Img.includes(IntakeSheetSession.dataBlock1)
      ? base64Img.replace(IntakeSheetSession.dataBlock1, IntakeSheetSession.dataBlock)
      : base64Img;
    setPatientSignImg(newBaseString);
    setSignDate(new Date());
    sessionStorage.setItem("sharedPatientSignature", newBaseString); // CHANGED
  };


  const ClearSignCall = () => {
    if (signRole === "Patient") {
      setPatientSignImg("");
      setSignDate("");
    }
  };


  return (
    <>
      {loading ? (
        <SpinnerLoader message="Loading form data…" />
      ) : (
        <div className="ha__wrapper">

          {/* ── Title ── */}
          <div className="ha__title-block">
            <div className="ha__title-main">
              AUTHORIZATION FOR RELEASE OF HEALTH INFORMATION PURSUANT TO HIPAA
            </div>
            <div className="ha__title-note">
              [This form has been approved by the New York state Department of Health]
            </div>
          </div>

          {/* ── Patient Info ── */}
          <div className="ha__section">
            <span className="ha__section-title">Patient Information</span>
            <span className="ha__section-line" />
          </div>

          <div className="ha__grid-row">
            <span className="ha__grid-label"><b>Name :</b></span>
            <div>
              <input
                className="ha__input"
                type="text"
                value={patientName}
                onChange={(e) => setPatientName(e.target.value)}
                disabled
              />
            </div>
            <span className="ha__grid-label"><b>Date Of Birth:</b></span>
            <div>
              <input
                className="ha__input"
                type="text"
                value={patientData?.patientDOB ? moment(patientData.patientDOB).format("MM/DD/YYYY") : "" }
                disabled
              />
            </div>
          </div>

          <div className="ha__grid-row">
            <span className="ha__grid-label"><b>Address :</b></span>
            <div>
              <textarea
                className="ha__textarea"
                value={generatePatientAddress()}
                disabled
              />
            </div>
            <span className="ha__grid-label"><b>SSN:</b></span>
            <div>
              <input
                className="ha__input"
                type="text"
                value={patientData?.ssn}
                disabled
              />
            </div>
          </div>

          {/* ── Legal Notices ── */}
          <div className="ha__section">
            <span className="ha__section-title">Legal Notice</span>
            <span className="ha__section-line" />
          </div>

          <div className="ha__legal-panel">
            <p>
              I, or my authorized representative, request that health information regarding my care and
              treatment as set forth on this form. In accordance with New York State Law and the Privacy
              Rule of the Health Insurance Portability and Accountability Act of 1996 (HIPAA), I understand that:
            </p>
            <p>
              1. This authorization may include disclosure of information relating to ALCOHOL and DRUG
              ABUSE, MENTAL HEALTH TREATMENT, except psychotherapy notes, and CONFIDENTIAL HIV*
              RELATED INFORMATION only if I place my initials on the appropriate line in Item 9(a).
            </p>
            <p>
              2. If I am authorizing the release of HIV-related, alcohol, or drug treatment, or mental health
              treatment information, the recipient is prohibited from redisclosing such information without my
              authorization unless permitted to do so under federal or state law.
            </p>
            <p>
              3. I have the right to revoke this authorization at any time by writing to the health care provider
              listed below.
            </p>
            <p>
              4. I understand that signing this authorization is voluntary. My treatment, payment, enrollment in
              a health plan, or eligibility for benefits will not be conditioned upon my authorization of this
              disclosure.
            </p>
            <p>
              5. Information disclosed under this authorization might be redisclosed by the recipient (except as
              noted above in Item 2), and this redisclosure may no longer be protected by federal or state law.
            </p>
            <p style={{ marginBottom: 0 }}>
              6. THIS AUTHORIZATION DOES NOT AUTHORIZE YOU TO DISCUSS MY HEALTH INFORMATION OR
              MEDICAL CARE WITH ANYONE OTHER THAN THE ATTORNEY OR GOVERNMENTAL AGENCY
              SPECIFIED IN ITEM 9 (b).
            </p>
          </div>

          {/* ── Item 7 ── */}
          <div className="ha__section">
            <span className="ha__section-title">7. Health Provider Info</span>
            <span className="ha__section-line" />
          </div>

          {/* {role.Name === "FrontDesk" || role.Name === "Admin" ? (
            <div className="ha__grid-row ha__grid-row--2col">
              <div>
                <input className="ha__input" type="text" value={tokenData.providerName || ""} readOnly />
              </div>
              <div>
                <textarea className="ha__textarea" value={providerAddress} onChange={() => {}} disabled />
              </div>
            </div>
          ) : ( */}
            <div style={{ marginBottom: 14 }}>
              <textarea className="ha__textarea" value={NameAddressHealthProviderInfo} disabled />
            </div>
          {/* )} */}

          {/* ── Item 8 ── */}
          <div className="ha__section">
            <span className="ha__section-title">8. Recipient Info</span>
            <span className="ha__section-line" />
          </div>
          <div style={{ marginBottom: 14 }}>
            <textarea
              className="ha__textarea"
              value={NameAddressOfPerson}
              onChange={(e) => setNameAddressOfPerson(e.target.value)}
            />
          </div>

          {/* ── Item 9a ── */}
          <div className="ha__section">
            <span className="ha__section-title">9(a). Specific Information to Release</span>
            <span className="ha__section-line" />
          </div>

          {/* Medical Record Date row */}
          {/* <div className="ha__check-row" style={{ marginBottom: 12 }}> */}
          {/* Medical Record Date row */}
          <div className="ha__check-row" style={{ marginBottom: 12, flexWrap: "nowrap" }}>
            <Checkbox
              checked={chkMedicalRecordDate}
              onChange={() => setChkMedicalRecordDate(!chkMedicalRecordDate)}
            />
            {/* <span className="ha__grid-label" style={{ paddingTop: 0 }}>Medical Record Form:</span> */}
            <span className="ha__grid-label" style={{ paddingTop: 0, whiteSpace: "nowrap" }}>Medical Record Form:</span>
            <DatePicker
              selected={medicalRecordForm}
              onChange={(e) => setMedicalRecordForm(e)}
              dateFormat="MM/dd/yyyy"
              className="ha__datepicker"
              showYearDropdown showMonthDropdown dropdownMode="select"
            />
            {/* <span className="ha__grid-label" style={{ paddingTop: 0 }}>Submit To:</span> */}
            <span className="ha__grid-label" style={{ paddingTop: 0, whiteSpace: "nowrap" }}>Submit To:</span>
            <DatePicker
              selected={submitToDate}
              onChange={(e) => setSubmitToDate(e)}
              dateFormat="MM/dd/yyyy"
              className="ha__datepicker"
              showYearDropdown showMonthDropdown dropdownMode="select"
            />
          </div>

          {/* Entire Medical Record */}
          <div className="ha__check-row" style={{ alignItems: 'flex-start', marginBottom: 12 }}>
            <Checkbox
              checked={chkEntireMedicalRecord}
              onChange={() => setChkEntireMedicalRecord(!chkEntireMedicalRecord)}
            />
            <span className="ha__grid-label" style={{ paddingTop: 4, flex: 1 }}>
              Entire Medical Record, including patient histories, office notes (except psychotherapy notes),
              test results, radiology studies, films, referrals, consults, billing records, insurance records,
              and records sent to you by other health care providers.
            </span>
          </div>

          {/* Other checkbox */}
          <div className="ha__check-row" style={{ marginBottom: 14 }}>
            <Checkbox
              checked={chkOther}
              onChange={() => setChkOther(!chkOther)}
            />
            <span className="ha__grid-label" style={{ paddingTop: 0 }}>Other:</span>
            <input
              className="ha__input"
              type="text"
              value={otherComment}
              onChange={(e) => setOtherComment(e.target.value)}
            />
          </div>

          {/* Include row */}
          <div className="ha__include-row">
            <span className="ha__include-label">Include: (Indicate by Initialing)</span>
            <div className="ha__field-group">
              <label>Alcohol/Drug Treatment</label>
              <input
                className="ha__input"
                type="text"
                value={alcohalDrugTreatment}
                onChange={(e) => setAlcohalDrugTreatment(e.target.value)}
              />
            </div>
            <div className="ha__field-group">
              <label>Mental Health Information</label>
              <input
                className="ha__input"
                type="text"
                value={mentalHealthInfo}
                onChange={(e) => setMentalHealthInfo(e.target.value)}
              />
            </div>
            <div className="ha__field-group">
              <label>HIV-Related Information</label>
              <input
                className="ha__input"
                type="text"
                value={HIVInfo}
                onChange={(e) => setHIVInfo(e.target.value)}
              />
            </div>
          </div>

          {/* ── Item 9b ── */}
          <div className="ha__section">
            <span className="ha__section-title">9(b). Authorization to Discuss Health Information</span>
            <span className="ha__section-line" />
          </div>

          <div className="ha__initials-row">
            <Checkbox
              checked={chkIntialting}
              onChange={() => setChkIntialting(!chkIntialting)}
            />
            <span className="ha__initials-word">By initialing here</span>
            <div className="ha__initials-field">
              <input
                className="ha__input"
                type="text"
                value={intialing}
                onChange={(e) => setIntialing(e.target.value)}
              />
            </div>
            <span className="ha__initials-word">I authorize</span>
            <div className="ha__initials-field">
              <input
                className="ha__input"
                type="text"
                value={authorize}
                onChange={(e) => setAuthorize(e.target.value)}
              />
            </div>
          </div>

          <div style={{ marginBottom: 8, fontSize: 13.5, fontWeight: 500, color: '#1e293b' }}>
            to discuss my health information with my attorney, or a governmental agency, listed here:
          </div>
          <div style={{ marginBottom: 18 }}>
            <textarea
              className="ha__textarea"
              value={discussHelathInfoWithAttorney}
              onChange={(e) => setDiscussHelathInfoWithAttorney(e.target.value)}
            />
          </div>

          {/* ── Item 10 ── */}
          <div className="ha__section">
            <span className="ha__section-title">10. Reason for Release</span>
            <span className="ha__section-line" />
          </div>

          <div className="ha__reason-row">
            <span className="ha__grid-label" style={{ paddingTop: 0 }}><b>Reason for release of information:</b></span>
            <label style={{ display: 'flex', alignItems: 'center', gap: 4, fontWeight: 600, fontSize: 13.5, cursor: 'pointer' }}>
              <Checkbox
                checked={chkRequestOfIndividualSubmit}
                onChange={() => setChkRequestOfIndividualSubmit(!chkRequestOfIndividualSubmit)}
              />
              At Request of Individual Submit
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: 4, fontWeight: 600, fontSize: 13.5, cursor: 'pointer' }}>
              <Checkbox
                checked={chkOtherReleaseInfo}
                onChange={() => setChkOtherReleaseInfo(!chkOtherReleaseInfo)}
              />
              Other
            </label>
          </div>

          {/* ── Item 11 ── */}
          <div className="ha__section">
            <span className="ha__section-title">11. Expiration</span>
            <span className="ha__section-line" />
          </div>

          <div className="ha__item-row">
            <span className="ha__grid-label"><b>Date or event on which this authorization will expire:</b></span>
            <DatePicker
              selected={expireDate}
              onChange={(e) => setExpireDate(e)}
              dateFormat="MM/dd/yyyy"
              className="ha__datepicker"
              showYearDropdown showMonthDropdown dropdownMode="select"
            />
          </div>

          {/* ── Item 12 ── */}
          <div className="ha__section">
            <span className="ha__section-title">12. Non-Patient Signatory</span>
            <span className="ha__section-line" />
          </div>

          <div className="ha__item-row">
            <span className="ha__grid-label"><b>If not the patient, name of person signing form:</b></span>
            <input
              className="ha__input"
              type="text"
              value={nameOfAnotherPreson}
              onChange={(e) => setNameOfAnotherPreson(e.target.value)}
            />
          </div>

          {/* ── Item 13 ── */}
          <div className="ha__section">
            <span className="ha__section-title">13. Authority to Sign</span>
            <span className="ha__section-line" />
          </div>

          <div className="ha__item-row" style={{ marginBottom: 18 }}>
            <span className="ha__grid-label"><b>Authority to sign on behalf of patient:</b></span>
            <input
              className="ha__input"
              type="text"
              value={authToSignBehalfOfPatient}
              onChange={(e) => setAuthToSignBehalfOfPatient(e.target.value)}
            />
          </div>

          {/* ── Completion notice ── */}
          <div className="ha__legal-box">
            All items on this form have been completed and my questions about this form have been answered.
            In addition, I have been provided a copy of the form.
          </div>

          {/* HIV disclaimer */}
          <div className="ha__legal-box">
            * Human Immunodeficiency Virus that causes AIDS. The New York State Public Health Law protects
            information which reasonably could identify someone as having HIV symptoms or infection and
            information regarding a person's contacts.
          </div>

          {/* ── Provider Name ── */}
          <div className="ha__item-row" style={{ marginBottom: 18 }}>
            <span className="ha__grid-label">Select the Provider Name to be printed on Form:</span>
            <input className="ha__input" type="text" value={tokenData.providerName} readOnly />
          </div>

          {/* ── Signature ── */}
          <div className="ha__section">
            <span className="ha__section-title">Signature</span>
            <span className="ha__section-line" />
          </div>

          <div className="ha__grid-row ha__grid-row--2col" style={{ alignItems: 'start' }}>
            <span className="ha__grid-label"><b>Signature :</b></span>
            <div>
              <div
                className={`ha__sign-box${!patientSignImg ? " ha__sign-box--empty" : ""}`}
                onClick={clickPatientSign}
              >
                {patientSignImg && (
                  <img src={patientSignImg} className="ha__sign-img" alt="Patient Signature" />
                )}
              </div>
            </div>
          </div>

          <div className="ha__grid-row ha__grid-row--2col ha__grid-row--center" style={{ marginTop: 12 }}>
            <span className="ha__grid-label"><b>Signature Date:</b></span>
            <DatePicker
              selected={SignDate}
              onChange={(d) => setSignDate(d)}
              dateFormat="MM/dd/yyyy"
              className="ha__datepicker"
              showYearDropdown showMonthDropdown dropdownMode="select"
            />
          </div>

          {/* ── Signature Pad ── */}
          {sigPadOpen && (
            <SignaturePad
              isOpen={sigPadOpen}
              title="Patient Signature"
              existingSign={patientSignImg}
              onClose={() => setSigPadOpen(false)}
              onSave={(base64) => { SignUpdatedCall(base64); setSigPadOpen(false); }}
              onClear={ClearSignCall}
            />
          )}
        </div>
      )}
    </>
  );
});

export default HippaAuth;